import { render, staticRenderFns } from "./VaAutocomplete.vue?vue&type=template&id=8dd62eae&scoped=true&"
import script from "./VaAutocomplete.vue?vue&type=script&scoped=true&lang=js&"
export * from "./VaAutocomplete.vue?vue&type=script&scoped=true&lang=js&"
import style0 from "./VaAutocomplete.vue?vue&type=style&index=0&id=8dd62eae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dd62eae",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
installComponents(component, {VAutocomplete})
